import { isProduction } from 'fergy-core-react-environment';
import { BAZAAR_VOICE_SCRIPT_BASE_URL_FERGUSON } from '../../constants/links';

const SCRIPT_NAME = 'bv.js';
const LANGUAGE = 'en_US';

type ContainerPageParams = {
	/**
	 * campaignId can be either the campaignId or the campaignName
	 */
	campaignId: string;
	productId: string;
};

export const buildContainerPageUrl = (BVParams: ContainerPageParams) => {
	const params = new URLSearchParams();

	params.append('bvaction', 'rr_submit_review');

	for (const param in BVParams) {
		if (BVParams[param]) {
			params.append(`bv${param}`, BVParams[param]);
		}
	}

	return `/product/reviews?${params.toString()}`;
};

/**
 * Generates the appropriate BazaarVoice script URL based on environment
 *
 * @returns string - the correct script URL
 */
export function generateScriptURL(baseURL: string = BAZAAR_VOICE_SCRIPT_BASE_URL_FERGUSON): string {
	const environment = isProduction ? 'production' : 'staging';
	return [baseURL, environment, LANGUAGE, SCRIPT_NAME].join('/');
}
